function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Facebookt");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "All-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home---1820x1024",
  transform: "translate(-930.000000, -794.000000)"
}, React.createElement("g", {
  id: "popup",
  transform: "translate(664.000000, 557.000000)"
}, React.createElement("g", {
  id: 2,
  transform: "translate(250.000000, 141.000000)"
}, React.createElement("g", {
  id: "Icons/Twitter",
  transform: "translate(16.000000, 96.000000)"
}, React.createElement("circle", {
  id: "Oval",
  fill: "#34ADFF",
  cx: 10,
  cy: 10,
  r: 10
}), React.createElement("g", {
  id: "twitter-(1)",
  strokeWidth: 1,
  transform: "translate(5.000000, 6.000000)",
  fill: "#FFFFFF"
}, React.createElement("path", {
  d: "M10.4,0.947076923 C10.028125,1.10769231 9.631875,1.21415385 9.21875,1.26584615 C9.64375,1.016 9.968125,0.623384615 10.120625,0.150153846 C9.724375,0.382769231 9.286875,0.547076923 8.820625,0.638769231 C8.444375,0.244307692 7.908125,0 7.323125,0 C6.188125,0 5.274375,0.907076923 5.274375,2.01907692 C5.274375,2.17907692 5.288125,2.33292308 5.321875,2.47938462 C3.6175,2.39753846 2.109375,1.59323077 1.09625,0.368 C0.919375,0.670153846 0.815625,1.016 0.815625,1.38830769 C0.815625,2.08738462 1.18125,2.70707692 1.72625,3.06584615 C1.396875,3.05969231 1.07375,2.96553846 0.8,2.81723077 C0.8,2.82338462 0.8,2.83138462 0.8,2.83938462 C0.8,3.82030769 1.510625,4.63507692 2.4425,4.82276923 C2.275625,4.86769231 2.09375,4.88923077 1.905,4.88923077 C1.77375,4.88923077 1.64125,4.88184615 1.516875,4.85476923 C1.7825,5.65415385 2.53625,6.24184615 3.4325,6.26092308 C2.735,6.79815385 1.849375,7.12184615 0.890625,7.12184615 C0.7225,7.12184615 0.56125,7.11446154 0.4,7.09415385 C1.308125,7.67076923 2.384375,8 3.545,8 C7.3175,8 9.38,4.92307692 9.38,2.256 C9.38,2.16676923 9.376875,2.08061538 9.3725,1.99507692 C9.779375,1.71076923 10.12125,1.35569231 10.4,0.947076923 Z",
  id: "Path"
})))))));

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.919895e1.svg";
export { ForwardRef as ReactComponent };